var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000012442421587495978070000000448219728710790560_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 8,
    y: 8,
    width: 87,
    height: 87
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118357113264680998110000014885565706019676607_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118357113264680998110000014885565706019676607_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3,33.7c-7,0-12.7,5.7-12.7,12.7c0,6.2,4.4,11.3,10.2,12.5v25.9c0,2.8-2.3,5.1-5.1,5.1c-2.8,0-5.1-2.3-5.1-5.1 c0-5.5,0,0,0-10.2c0-5.6-4.6-10.2-10.2-10.2c-5.6,0-10.2,4.6-10.2,10.2c0,3.6,0,6.6,0,10.2c0,2.8-2.3,5.1-5.1,5.1 c-2.9,0-5.3-2.3-5.3-5.1V64.1c3.1-0.7,5.9-2.8,7.5-5.6c0,0,16.2-28.5,16.8-29.6c0.9-1.6,1.4-3.4,1.4-5.3c0-5.7-4.5-10.4-10.2-10.6 v-2.6c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v10.2c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-2.5c2.8,0.2,5.1,2.6,5.1,5.5 c0,1-0.3,1.9-0.7,2.7l-9.9,17.4h-25l-9.9-17.4c-0.5-0.8-0.7-1.8-0.7-2.7c0-2.9,2.3-5.3,5.1-5.5v2.5c0,1.4,1.1,2.5,2.6,2.5 c1.4,0,2.5-1.1,2.5-2.5V10.6c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.6,1.1-2.6,2.5v2.6C12.5,13.3,8,18,8,23.7c0,1.8,0.5,3.7,1.4,5.3 c0.5,0.8,16.8,29.6,16.8,29.6c1.6,2.8,4.4,4.8,7.5,5.6v20.7C33.7,90.5,38.4,95,44,95c5.6,0,10.2-4.6,10.2-10.2c0-5.5,0,0,0-10.2 c0-2.8,2.3-5.1,5.1-5.1c2.8,0,5.1,2.3,5.1,5.1c0,3.6,0,6.6,0,10.2C64.4,90.4,69,95,74.6,95c5.6,0,10.2-4.6,10.2-10.2V58.9 C90.6,57.7,95,52.6,95,46.4C95,39.4,89.3,33.7,82.3,33.7z M36.2,59.3c-2.2,0-4.5-1.3-5.6-3.3l-4-7.1h19.2l-4,7.1 C40.7,58,38.4,59.3,36.2,59.3z M82.3,54c-4.2,0-7.6-3.4-7.6-7.6c0-4.2,3.4-7.6,7.6-7.6c4.2,0,7.6,3.4,7.6,7.6 C89.9,50.6,86.5,54,82.3,54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3,49c1.4,0,2.6-1.1,2.6-2.5c0-1.4-1.1-2.5-2.6-2.5c-1.4,0-2.5,1.1-2.5,2.5C79.7,47.8,80.8,49,82.3,49z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalMedicine);
export default __webpack_public_path__ + "static/media/internalMedicine.99aa7cb2db0ccc0ad2a44049dd487dca.svg";
export { ForwardRef as ReactComponent };